import assetIcWishlistEmpty from './ic-wishlist-empty.svg';
import assetIcWishlist from './ic-wishlist.svg';
export enum WishlistIconName {
  Wishlist = 'Wishlist',
  WishlistEmpty = 'WishlistEmpty',
}

export const wishlistIconAssets: {[key in WishlistIconName]: string} = {
  [WishlistIconName.Wishlist]: assetIcWishlist,
  [WishlistIconName.WishlistEmpty]: assetIcWishlistEmpty,
};
